/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';

/**
 * 
 * @export
 * @interface ContactPerson
 */
export interface ContactPerson {
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    id: string;
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof ContactPerson
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    mobile?: string;
    /**
     * 
     * @type {ContactPersonContactTypeEnum}
     * @memberof ContactPerson
     */
    contactType: ContactPersonContactTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ContactPerson
     */
    createdAt: Date;
}


/**
 * @export
 */
export const ContactPersonContactTypeEnum = {
    Delivery: 'DELIVERY',
    Invoice: 'INVOICE',
    Contractual: 'CONTRACTUAL',
    Other: 'OTHER'
} as const;
export type ContactPersonContactTypeEnum = typeof ContactPersonContactTypeEnum[keyof typeof ContactPersonContactTypeEnum];


/**
 * Check if a given object implements the ContactPerson interface.
 */
export function instanceOfContactPerson(value: object): value is ContactPerson {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('mail' in value) || value['mail'] === undefined) return false;
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ContactPersonFromJSON(json: any): ContactPerson {
    return ContactPersonFromJSONTyped(json, false);
}

export function ContactPersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPerson {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'mail': json['mail'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'contactType': json['contactType'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ContactPersonToJSON(json: any): ContactPerson {
    return ContactPersonToJSONTyped(json, false);
}

export function ContactPersonToJSONTyped(value?: ContactPerson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'mail': value['mail'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'contactType': value['contactType'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

